import ConnectPage from "./ConnectPage";

export default ConnectPage;